import React, { useState, useEffect, useContext } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { Dropdown } from "react-bootstrap";
import "./styles.css"
import BackImage from "../../background/geom-pattern.jpeg"
import AuthService from '../../services/AuthService';
import FinishProcessIcon from "../../assets/finish_icon.svg";
import DatasetUtils from '../../services/DatasetUtils';

import LeftSpliter from "../../assets/leftSpliter.svg"
import RightSpliter from "../../assets/rightSpliter.svg"
import MobileSpliter from "../../assets/mobileSpliter.svg"
import Notification from "../../assets/notification.svg"
import Waiting from "../../assets/waiting.svg"
import WindowSizeContext from "../../utils/WindowSizeContext"
import { clearLS } from '../../utils/ClearLocalStorage';

export const Navigation = (props) => {
    const navigate = useNavigate();
    const currentPath = useLocation().pathname;
    const [dropMenuOpen, setDropMenuOpen] = useState(false);
    const [allDatasets, setAllDatasets] = useState([])
    const [statuses, setStatuses] = useState([])
    const [statusMenu, setStatusMenu] = useState(false)

    const HOME_PATH = "/"
    const MAP_PATH = '/map'
    const LK_PATH = '/lk'

    const size = useContext(WindowSizeContext);

    const datasetsContainer = useSelector((store) => { return store.datasetsReducer })
    const userContainer = useSelector((store) => { return store.userReducer.userInfo })


    useEffect(() => {
        if (datasetsContainer) {
            setAllDatasets(datasetsContainer.datasets)

            if (datasetsContainer.datasets) {
                let runningStatuses = [];
                datasetsContainer.datasets.forEach((dataset) => {
                    if (dataset.runningTasks) {
                        dataset.runningTasks.forEach((task) => {
                            runningStatuses.push({
                                name: dataset.name,
                                operation: DatasetUtils.getNameProgress(task.performer),
                                status: task.lastInfo.progress * 100
                            });
                        });
                    }
                    if (dataset.connect && dataset.connect.stage === "readyToCheck") {
                        runningStatuses.push({
                            name: dataset.name + ' - ждет проверки',
                            operation: DatasetUtils.getNameProgress("lk_connector"),
                            status: 100,
                            icon: FinishProcessIcon
                        });
                    }
                })
                setStatuses(runningStatuses);
            }
        }
    }, [datasetsContainer])

    function navMenuClickClose() {
        document.getElementById('nav-background').style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
        document.getElementById('nav-drop-button').style.transform = 'rotate(0deg)';
        document.getElementById('nav-list-menu').style.maxHeight = '0';
        setDropMenuOpen(false);
    }

    function navMenuClickOpen() {
        document.getElementById('nav-background').style.backgroundColor = 'rgba(209, 208, 208, 0.3)';
        document.getElementById('nav-drop-button').style.transform = 'rotate(180deg)';
        document.getElementById('nav-list-menu').style.maxHeight = '666px';
        setDropMenuOpen(true);
    }

    function getUserActivesList() {
        let listOfActs = []
        if (userContainer && userContainer.authorized && userContainer.username) {
            listOfActs.push(
                {
                    name: 'загруженные наборы данных',
                    onClick: () => {
                        userContainer && userContainer.authorized ?
                            navigate('/lk/MyDatasets')
                            :
                            props.showLoginForm && props.showLoginForm();
                    }
                },
                {
                    name: 'выйти из учетки «' + userContainer.username + '»',
                    onClick: () => {
                        AuthService.performLogout((result) => {
                            if (props.afterLogout) {
                                props.afterLogout();
                            }
                            else {
                                navigate('/');
                            }
                        });
                    }
                }
            )
        }
        // if (this.someForDownload) {
        // return this.someForDownload.map((file, index) => (
        //     <Dropdown.Item href={"/exportedDatasets" + file.file} key={index + 'listDrop'}><p key={index} className="downloadLink">
        //        {(file.file.indexOf(".geojson") >= 0 ? "GeoJSON" : "XLSX") + " от " + prettyDateTime(new Date(parseInt(file.time)))}
        //     </p>
        //     </Dropdown.Item>
        // ))
        // }
        return listOfActs.map((act, index) => (
            <Dropdown.Item key={index + 'listDrop'} onClick={() => act.onClick()}><p key={index} className="actLink">
                {act.name}
            </p>
            </Dropdown.Item>
        ))
    }

    return (
        <>
            <div className="Navigation">
                <div id='nav-panel' className='nav-header-line'>
                    <div className='nav-wrapper'>
                        <div className='nav-background' id='nav-background' />
                        {currentPath !== HOME_PATH && <div className='background-nav'>
                            <img src={BackImage} alt='background' id='backgroundNav' className='background-image-nav' />
                        </div>}
                        <div className='nav-content'>
                            <div className={(size.width > 300 ? 'nav-title' : 'no-display') + (currentPath === HOME_PATH ? '' : ' active-page-border')}>
                                <p className={'nav-text unselectable' + (currentPath === HOME_PATH ? '' : ' cursor-pointer')} onClick={() => { currentPath !== '/' && navigate('/') }}>Робот-Картограф</p>
                            </div>
                            {size.width <= 768 ?
                                <div className={`nav-svg-container ${!(userContainer && userContainer.authorized && userContainer.username) ? 'non-authorized' : ''}`}>
                                    <img className='spliter mobile' src={MobileSpliter} />
                                </div> : <></>}
                            {size.width > 768 ?
                                <div className={`nav-svg-container ${!(userContainer && userContainer.authorized && userContainer.username) ? 'non-authorized' : ''}`}>
                                    <img className="spliter left" src={LeftSpliter} />
                                </div> : <></>}
                            <div className={`nav-page ${currentPath === MAP_PATH ? '' : 'active-page-border'}`} onClick={() => navigate('/map')}>
                                <p className={`nav-text unselectable ${currentPath === MAP_PATH ? '' : 'cursor-pointer'}`}>Карта</p>
                            </div>
                            {size.width > 768 ?
                                <div className={`nav-svg-container ${!(userContainer && userContainer.authorized && userContainer.username) ? 'non-authorized' : ''}`} style={{ position: 'relative', left: '45px' }}>
                                    <img className="spliter right" src={RightSpliter} />
                                </div> : <></>}
                            <div className={`nav-user ${!(userContainer && userContainer.authorized && userContainer.username) ? 'non-authorized' : ''} ${size.width <= 768 ? '' : (userContainer && userContainer.authorized && userContainer.username ? '' : 'active-page-border')}`}>
                                {/* <span
                                        className={'nav-button unselectable cursor-pointer ' + (current === '/lk' ? ' active-page' : '')}
                                        onClick={() => {
                                            userContainer && userContainer.authorized ?
                                                navigate('/lk')
                                                :
                                                props.showLoginForm && props.showLoginForm();
                                        }}>
                                        {'Личный кабинет: ' + (userContainer && userContainer.authorized ? userContainer.username : 'войти')}
                                    </span> */}
                                {(userContainer && userContainer.authorized && userContainer.username) ?
                                    <>
                                        {(allDatasets && allDatasets.length > 0) ?
                                            <img src={Notification} alt='bellIcon' onClick={() => setStatusMenu(!statusMenu)} className={'notification-icon cursor-pointer'} />
                                            :
                                            <img src={Waiting} alt='bellIcon' className={'waiting notification-icon '} />}

                                        {statusMenu && allDatasets && <div className='historyContainer'>
                                            <div className='listofStatuses'>
                                                {(!statuses || (statuses.length === 0)) &&
                                                    <div className='statusText'>здесь будут уведомления о ваших операциях</div>
                                                }
                                                {statuses && statuses.map((status, i) => {
                                                    return <div className='statusElement' key={'status' + i}>
                                                        <div className='headerStatus'>
                                                            <div>{status.operation}</div>
                                                            {/* {status.status !== '100' ? <div className='cancelButton'><img className='iconOfStatuses' src={CancelIcon} alt='cancelIcon' />Отменить</div> : <div className='openDatasetButton'><img className='iconOfStatuses' src={EyeIcon} alt='openDatasetIconIcon' />Датасет</div>} */}
                                                        </div>
                                                        {status.status === '100' ?
                                                            <div className='statusBarFull'></div>
                                                            :
                                                            <><div className='statusBar'></div><div style={{ width: status.status + '%' }} className='statusBar2'></div></>
                                                        }
                                                        <div className='statusDatasetName'>
                                                            {status.name}
                                                            {status.icon && <img className='dataset-info-notify' src={status.icon} alt='notify' />}
                                                        </div>
                                                    </div>
                                                })
                                                }</div>
                                        </div>}


                                        <Dropdown
                                            className={`nav-button unselectable user-name-container ${currentPath.indexOf(LK_PATH) >= 0 ? '' : 'active-page-border cursor-pointer'}`}
                                            key='dropdownChooseNav'
                                        >
                                            <Dropdown.Toggle id='navDrop' className="dropDatasetButton" variant="success">
                                                <p className='user-name-text'>
                                                    {"Мои данные"}
                                                </p>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className='dropMenuDownload'>
                                                <div className='dropListClass' id="dropdownChooseNav" >
                                                    {userContainer && userContainer.authorized && getUserActivesList()}
                                                </div>
                                            </Dropdown.Menu>
                                        </Dropdown></>
                                    :
                                    <span className={`nav-button unselectable ${props.isLoginShow ? 'show-login-form' : ''}`}
                                        onClick={() => { console.log(props.showLoginForm); props.showLoginForm && props.showLoginForm() }}>
                                        Войти
                                    </span>

                                }
                                {/* <span className='nav-button unselectable' >Пользователь</span>
                                <img src={dropArrow} alt='dropArrow' className='dropArrow'/> */}
                            </div>
                            {/* <img className={size.dropMenu ? 'nav-drop-button unselectable' : 'no-display'} alt="dropicon" id="nav-drop-button" src={DropIcon}
                                onClick={!dropMenuOpen ? navMenuClickOpen : navMenuClickClose}
                            /> */}
                            {/* <div className={'nav-list-menu'} id='nav-list-menu'>
                                <ul className='nav-ul-menu'>
                                    <li className='nav-li-menu unselectable' onClick={() => { navigate('/map') }}>Карта</li>
                                    <li className='nav-li-menu unselectable' onClick={() => { navigate('/') }}>Главная</li>
                                    <li className='nav-li-menu unselectable' onClick={() => {
                                        userContainer && userContainer.authorized ?
                                            navigate('/lk') :
                                            props.showLoginForm && props.showLoginForm();
                                    }}>
                                        {'Личный кабинет: ' + (userContainer && userContainer.authorized ? userContainer.username : 'войти')}
                                    </li>
                                    {userContainer && userContainer.authorized &&
                                        <li className='nav-li-menu unselectable' onClick={() => {
                                            AuthService.performLogout((result) => {
                                                if (props.afterLogout) {
                                                    props.afterLogout();
                                                }
                                                else {
                                                    navigate('/');
                                                }
                                            });
                                        }}>Выйти</li>
                                    }
                                </ul>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Navigation;